const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');
const ToUpperCase = require('../transforms/ToUpperCase');
const ToLowerCase = require('../transforms/ToLowerCase');
const ToBoolean = require('../transforms/ToBoolean');
const ToNumber = require('../transforms/ToNumber');
const ToHexFromAscii = require('../transforms/ToHexFromAscii');
const ToAsciiFromHex = require('../transforms/ToAsciiFromHex');
const DefaultToPreviousSelection = require('../transforms/DefaultToPreviousSelection');
const TabAfterScan = require('../transforms/TabAfterScan');
const ActionAfterScan = require('../transforms/ActionAfterScan');

module.exports = class ShortText extends Builder {
    constructor(title, properties) {
        super('formElement_ShortText', title, properties);
    }

    /**
     * @param {string} role
     */
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    /**
     * @param {boolean} transformInline
     */
    transformToUpperCase(transformInline) {
        let transform = new ToUpperCase({ transformInline });
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    /**
     * @param {boolean} transformInline
     */
    transformToLowerCase(transformInline) {
        let transform = new ToLowerCase({ transformInline });
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    /**
     * @param {string} falseValues
     */
    transformToBoolean(falseValues) {
        let transform = new ToBoolean({ falseValues });
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformToNumber() {
        let transform = new ToNumber();
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformToAsciiFromHex() {
        let transform = new ToAsciiFromHex();
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformToHexFromAscii() {
        let transform = new ToHexFromAscii();
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformDefaultToPreviousSelection() {
        let transform = new DefaultToPreviousSelection();
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformTabAfterScan() {
        let transform = new TabAfterScan();
        this.addChildBlock(transform, 'transforms');
        return this;
    }
    transformActionAfterScan() {
        let transform = new ActionAfterScan();
        this.addChildBlock(transform, 'transforms');
        return this;
    }
};
